import { Game, Scores } from '/src/store'
import SubService, { ACCESS_FREE, ACCESS_PRO } from '/src/services/SubService'
import StrapiService from '@/services/StrapiService'
import { reactive } from 'vue'

export const GAME_LENGTH = 10

export const GAME_THRESHOLD = 200

export const GAME_INTERRUPT_THRESHOLD = 100

// Reactive cache for quiz stats
const store = reactive({
  stats: null
})

const GameService = {
  addBalance(val) {
    Scores.addBalance(val)
    Scores.addProfit(val)
  },

  removeBalance(val) {
    Scores.removeBalance(val)
    Scores.addLoss(val)
  },

  addAnsweredQuestion({ question, correct }) {
    return Game.addAnsweredQuestion(question.original_id ?? question.id, correct)
  },

  getAnsweredQuestions() {
    return Game.getAnsweredQuestions()
  },
  // /**
  //  * @param {String|Number} [access] Options. Omit to get questions for current user plan.
  //  * @returns {Promise<*>}
  //  */
  // async getQuestions(access) {
  //   const { data: questions } = await StrapiService.getContentType('game-questions')
  //   return questions?.data.filter(q => SubService.hasAccess(q, access)) || []
  // },

  /**
   *
   * @param {Boolean} refresh
   * @returns {Promise<*>}
   */
  async getStats(refresh = false) {
    if (!refresh && store.stats) {
      return store.stats;
    }

    const { data: stats } = await StrapiService.getContentType('game-questions/stats')

    store.stats = stats

    return store.stats
  },

  async getGameQuestions() {
    const answered = Game.getAnsweredQuestions()
      .reduce((map, q) => {
        map[q.game_question_id] = q.correct
        return map
      }, {})

    const accessible = SubService.getAccessiblePackages()

    // Get all accessible questions and shuffle
    const { data: questions } = await StrapiService.searchContentType(
      'game-questions/random',
      {
        filters: {
          package_id: {
            $in: accessible
          },
        },
        limit: GAME_LENGTH
      },
      {
        answered
      })

    return questions
  },

  /**
   * Shorthand for resolving question packages for answered questions
   * @returns {Promise<HttpResponse>}
   */
  resolveQuestionPackages () {
    return StrapiService.getContentType('game-questions', {
      fields: [
        'id',
        'original_id',
        'package_id'
      ]
    })
  },

  isLocked(score, plan) {
    // Show open for dev mode
    if (import.meta.env.MODE === 'development') return false;

    return plan !== ACCESS_PRO && score < GAME_THRESHOLD;
  },

  isInterrupted() {
    if (import.meta.env.MODE === 'development') return false;

    return SubService.state.plan === ACCESS_FREE && Scores.getBalance() < GAME_INTERRUPT_THRESHOLD;
  }
}

export default GameService
